// extracted by mini-css-extract-plugin
module.exports = {"FlipFlop":"flip-flop_FlipFlop__1aR5T","right":"flip-flop_right__1B0am","left":"flip-flop_left__Z5lAA","image":"flip-flop_image__33dUh","appear":"flip-flop_appear__2HoKh"};